import { useQuery } from "react-query";
import LoadingWrapper from "../../../components/Loading/LoadingWrapper";
import useAPI from "../../../hooks/useAPI"
import useRefreshQuery, { GlobalQueries } from "../../../hooks/useRefreshQuery"
import scss from "./NotificationDetails.module.scss"

/**
 * Show the details of a single notification.
 *
 * @param {?int} notificationId The id of the notification to show.
 *
 * @return {JSX.Element}
 * @constructor
 */
const NotificationDetails = ({ notificationId }) => {
  const api = useAPI()

  // Load all notifications
  const { data: notification, isLoading } = useQuery(
    [`Notification.${notificationId}`],
    () => api.get(`/notifications/${notificationId}`)
  )

  // Refresh the global notifications
  useRefreshQuery(GlobalQueries.Notifications, notification)

  const convertDate = (date) => {
    const options = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    };

    const dateObj = new Date(date);
    const formattedDate = dateObj.toLocaleString("sr-RS", options)
      .replace(/,/g, '')
      .replace(/(\d+)\D+(\d+)\D+(\d+)\D+(\d+):(\d+)/, '$1.$2.$3, $4:$5');
    return formattedDate;
  };


  return (
    <div className={scss.wrapper}>
      <LoadingWrapper isLoading={isLoading}>
        {notification && (
          <article>
            <header className={scss.header}>
              <h2>{notification.title}</h2>
              <time dateTime={notification.created_at}>{convertDate(notification.created_at)}</time>
            </header>
            <div className={scss.message}>{notification.message}</div>
            {notification.button && (
              <a className={scss.button} target="_blank" rel="noopener noreferrer" href={notification.link}>
                {notification?.button}
              </a>
            )}
          </article>
        )}
      </LoadingWrapper>
    </div>
  )
}

export default NotificationDetails
